import { ChampLibre, ChampLibreAPI } from './champLibre';
import { Materiel, MaterielAPI } from './materiel';
export class TableauDeBord {
  ai?: ChampLibre;
  aiMin?: ChampLibre;
  aiMax?: ChampLibre;
  arretTabac?: ChampLibre;
  commentaire?: ChampLibre;
  deambulation?: ChampLibre;
  debit02Repos?: ChampLibre;
  debit02Effort?: ChampLibre;
  debitMin?: ChampLibre;
  debitMax?: ChampLibre;
  duree?: ChampLibre;
  dureeMin?: ChampLibre;
  dureeMax?: ChampLibre;
  epap?: ChampLibre; // EPAP = PEP
  epapMin?: ChampLibre; // EPAP = PEP
  epapMax?: ChampLibre; // EPAP = PEP
  epap95?: ChampLibre; // EPAP = PEP
  frequence?: ChampLibre;
  frequenceRespiratoireMediane?: ChampLibre;
  frequenceRespiratoire95?: ChampLibre;
  fuites?: ChampLibre;
  fuitesMediane?: ChampLibre;
  fuites95?: ChampLibre;
  iahInitial?: ChampLibre;
  iahResiduel?: ChampLibre;
  ipap?: ChampLibre;
  ipap95?: ChampLibre;
  mode?: ChampLibre;
  obs?: ChampLibre;
  pressionFixe?: ChampLibre;
  pressionMinimale?: ChampLibre;
  pressionMaximale?: ChampLibre;
  p90_95?: ChampLibre;
  spo2AvecO2?: ChampLibre;
  spo2SansO2?: ChampLibre;
  traitement?: ChampLibre;
  typeDeMasque?: ChampLibre;
  volumeCourant?: ChampLibre;
  volumeCourantMediane?: ChampLibre;
  volumeCourant95?: ChampLibre;
  activite?: string;
  materielEnlocationList?: Materiel[];
  materielVenduList?: Materiel[];

  constructor(
    ai?: ChampLibre,
    aiMin?: ChampLibre,
    aiMax?: ChampLibre,
    arretTabac?: ChampLibre,
    commentaire?: ChampLibre,
    deambulation?: ChampLibre,
    debit02Repos?: ChampLibre,
    debit02Effort?: ChampLibre,
    debitMin?: ChampLibre,
    debitMax?: ChampLibre,
    duree?: ChampLibre,
    dureeMin?: ChampLibre,
    dureeMax?: ChampLibre,
    epap?: ChampLibre,
    epapMin?: ChampLibre,
    epapMax?: ChampLibre,
    epap95?: ChampLibre,
    frequence?: ChampLibre,
    frequenceRespiratoireMediane?: ChampLibre,
    frequenceRespiratoire95?: ChampLibre,
    fuites?: ChampLibre,
    fuitesMediane?: ChampLibre,
    fuites95?: ChampLibre,
    iahInitial?: ChampLibre,
    iahResiduel?: ChampLibre,
    ipap?: ChampLibre,
    ipap95?: ChampLibre,
    mode?: ChampLibre,
    obs?: ChampLibre,
    pressionFixe?: ChampLibre,
    pressionMinimale?: ChampLibre,
    pressionMaximale?: ChampLibre,
    p90_95?: ChampLibre,
    spo2AvecO2?: ChampLibre,
    spo2SansO2?: ChampLibre,
    traitement?: ChampLibre,
    typeDeMasque?: ChampLibre,
    volumeCourant?: ChampLibre,
    volumeCourantMediane?: ChampLibre,
    volumeCourant95?: ChampLibre,
    activite?: string,
    materielEnlocationList?: Materiel[],
    materielVenduList?: Materiel[],
  ) {
    this.ai = ai;
    this.aiMin = aiMin;
    this.aiMax = aiMax;
    this.arretTabac = arretTabac;
    this.commentaire = commentaire;
    this.deambulation = deambulation;
    this.debit02Repos = debit02Repos;
    this.debit02Effort = debit02Effort;
    this.debitMin = debitMin;
    this.debitMax = debitMax;
    this.duree = duree;
    this.dureeMin = dureeMin;
    this.dureeMax = dureeMax;
    this.epap = epap;
    this.epapMin = epapMin;
    this.epapMax = epapMax;
    this.epap95 = epap95;
    this.frequence = frequence;
    this.frequenceRespiratoireMediane = frequenceRespiratoireMediane;
    this.frequenceRespiratoire95 = frequenceRespiratoire95;
    this.fuites = fuites;
    this.fuitesMediane = fuitesMediane;
    this.fuites95 = fuites95;
    this.iahInitial = iahInitial;
    this.iahResiduel = iahResiduel;
    this.ipap = ipap;
    this.ipap95 = ipap95;
    this.mode = mode;
    this.obs = obs;
    this.pressionFixe = pressionFixe;
    this.pressionMinimale = pressionMinimale;
    this.pressionMaximale = pressionMaximale;
    this.p90_95 = p90_95;
    this.spo2AvecO2 = spo2AvecO2;
    this.spo2SansO2 = spo2SansO2;
    this.traitement = traitement;
    this.typeDeMasque = typeDeMasque;
    this.volumeCourant = volumeCourant;
    this.volumeCourantMediane = volumeCourantMediane;
    this.volumeCourant95 = volumeCourant95;
    this.activite = activite;
    this.materielEnlocationList = materielEnlocationList;
    this.materielVenduList = materielVenduList;
  }

  static factory(tableauDeBordAPI: TableauDeBordAPI): TableauDeBord {
    var ai: ChampLibre | undefined = undefined;
    var aiMin: ChampLibre | undefined = undefined;
    var aiMax: ChampLibre | undefined = undefined;
    var arretTabac: ChampLibre | undefined = undefined;
    var commentaire: ChampLibre | undefined = undefined;
    var deambulation: ChampLibre | undefined = undefined;
    var debit02Repos: ChampLibre | undefined = undefined;
    var debit02Effort: ChampLibre | undefined = undefined;
    var debitMin: ChampLibre | undefined = undefined;
    var debitMax: ChampLibre | undefined = undefined;
    var duree: ChampLibre | undefined = undefined;
    var dureeMin: ChampLibre | undefined = undefined;
    var dureeMax: ChampLibre | undefined = undefined;
    var epap: ChampLibre | undefined = undefined;
    var epapMin: ChampLibre | undefined = undefined;
    var epapMax: ChampLibre | undefined = undefined;
    var epap95: ChampLibre | undefined = undefined;
    var frequence: ChampLibre | undefined = undefined;
    var frequenceRespiratoireMediane: ChampLibre | undefined = undefined;
    var frequenceRespiratoire95: ChampLibre | undefined = undefined;
    var fuites: ChampLibre | undefined = undefined;
    var fuitesMediane: ChampLibre | undefined = undefined;
    var fuites95: ChampLibre | undefined = undefined;
    var iahInitial: ChampLibre | undefined = undefined;
    var iahResiduel: ChampLibre | undefined = undefined;
    var ipap: ChampLibre | undefined = undefined;
    var ipap95: ChampLibre | undefined = undefined;
    var mode: ChampLibre | undefined = undefined;
    var obs: ChampLibre | undefined = undefined;
    var pressionFixe: ChampLibre | undefined = undefined;
    var pressionMinimale: ChampLibre | undefined = undefined;
    var pressionMaximale: ChampLibre | undefined = undefined;
    var p90_95: ChampLibre | undefined = undefined;
    var spo2AvecO2: ChampLibre | undefined = undefined;
    var spo2SansO2: ChampLibre | undefined = undefined;
    var traitement: ChampLibre | undefined = undefined;
    var typeDeMasque: ChampLibre | undefined = undefined;
    var volumeCourant: ChampLibre | undefined = undefined;
    var volumeCourantMediane: ChampLibre | undefined = undefined;
    var volumeCourant95: ChampLibre | undefined = undefined;

    var champLibreList: ChampLibreAPI[] =
      tableauDeBordAPI.ChampsLibres.CliChampLibre instanceof Array
        ? tableauDeBordAPI.ChampsLibres.CliChampLibre
        : tableauDeBordAPI.ChampsLibres.CliChampLibre
          ? [tableauDeBordAPI.ChampsLibres.CliChampLibre]
          : [];

    champLibreList.forEach((champLibreAPI) => {
      const champLibre = ChampLibre.factory(champLibreAPI);

      switch (champLibre.libelle) {
        case 'AI':
          ai = champLibre;
          break;

        case 'AI MIN':
          aiMin = champLibre;
          break;

        case 'AI MAX':
          aiMax = champLibre;
          break;

        case 'ARRET TABAC':
          arretTabac = champLibre;
          break;

        case 'COMMENTAIRES':
          champLibre.value = commentaire
            ? `${commentaire.value} \n ${champLibre.value}`
            : champLibre.value;
          commentaire = champLibre;
          break;

        case 'COMMENT bis champs libres':
          champLibre.value = commentaire
            ? `${champLibre.value} \n ${commentaire.value}`
            : champLibre.value;
          commentaire = champLibre;
          break;

        case 'PRESENSE D\"UN DM DEAMBULATION':
          deambulation = champLibre;
          break;

        case 'DEBIT O2 EFFORT':
          debit02Effort = champLibre;
          break;

        case 'DEBIT O2 REPOS':
          debit02Repos = champLibre;
          break;

        case 'DEBIT MIN':
          debitMin = champLibre;
          break;

        case 'DEBIT MAX':
          debitMax = champLibre;
          break;

        case 'DUREE PRESCRITE - H sur 24H':
          duree = champLibre;
          break;

        case 'DUREE MIN':
          dureeMin = champLibre;
          break;

        case 'DUREE MAX':
          dureeMax = champLibre;
          break;

        case 'EPAP':
          epap = champLibre;
          break;

        case 'EPAP MIN':
          epapMin = champLibre;
          break;

        case 'EPAP MAX':
          epapMax = champLibre;
          break;

        case 'EPAP 95 CENTILE':
          epap95 = champLibre;
          break;

        case 'FREQUENCE':
          frequence = champLibre;
          break;

        case 'FREQUENCE MEDIANE RELEVEE':
          frequenceRespiratoireMediane = champLibre;
          break;

        case 'FREQUENCE 95 CENTILE RELEVEE':
          frequenceRespiratoire95 = champLibre;
          break;

        case 'FUITES':
          fuites = champLibre;
          break;

        case 'FUITES MEDIANES RELEVEES en L\\MIN':
          fuitesMediane = champLibre;
          break;

        case 'FUITES 95 CENTILE RELEVEES en L\\MIN':
          fuites95 = champLibre;
          break;

        case 'IAH INITIAL':
          iahInitial = champLibre;
          break;

        case 'IAH RESIDUEL':
          iahResiduel = champLibre;
          break;

        case 'IPAP':
          ipap = champLibre;
          break;

        case 'IPAP  95 CENTILE':
          ipap95 = champLibre;
          break;

        case 'MODE':
          mode = champLibre;
          break;

        case 'OBS':
          obs = champLibre;
          break;

        case 'PRESSION FIXE':
          pressionFixe = champLibre;
          break;

        case 'PRESSION MAX':
          pressionMaximale = champLibre;
          break;

        case 'PRESSION MINI.':
          pressionMinimale = champLibre;
          break;

        case 'P90/95':
          p90_95 = champLibre;
          break;

        case 'spO2 avec O2':
          spo2AvecO2 = champLibre;
          break;

        case 'spO2 sans O2':
          spo2SansO2 = champLibre;
          break;

        case 'TRAITEMENT':
          traitement = champLibre;
          break;

        case 'TYPE MASQUE':
          typeDeMasque = champLibre;
          break;

        case 'VT - VT CIBLE':
          volumeCourant = champLibre;
          break;

        case 'VT MEDIAN RELEVE EN ML':
          volumeCourantMediane = champLibre;
          break;

        case 'VT 95 CENTILE RELEVE EN ML':
          volumeCourant95 = champLibre;
          break;

        default:
          break;
      }
    });

    return new TableauDeBord(
      ai,
      aiMin,
      aiMax,
      arretTabac,
      commentaire,
      deambulation,
      debit02Repos,
      debit02Effort,
      debitMin,
      debitMax,
      duree,
      dureeMin,
      dureeMax,
      epap,
      epapMin,
      epapMax,
      epap95,
      frequence,
      frequenceRespiratoireMediane,
      frequenceRespiratoire95,
      fuites,
      fuitesMediane,
      fuites95,
      iahInitial,
      iahResiduel,
      ipap,
      ipap95,
      mode,
      obs,
      pressionFixe,
      pressionMinimale,
      pressionMaximale,
      p90_95,
      spo2SansO2,
      spo2AvecO2,
      traitement,
      typeDeMasque,
      volumeCourant,
      volumeCourantMediane,
      volumeCourant95,

      tableauDeBordAPI.LignesLoc.CliLigneLoc instanceof Array
        ? tableauDeBordAPI.LignesLoc.CliLigneLoc[0]?.ActivityCode
        : tableauDeBordAPI.LignesLoc.CliLigneLoc?.ActivityCode,

      tableauDeBordAPI.LignesLoc.CliLigneLoc instanceof Array
        ? tableauDeBordAPI.LignesLoc.CliLigneLoc.filter(
            (materielAPI) => materielAPI.LignePrixHT === 0,
          ).map((materielAPI) => Materiel.factory(materielAPI))
        : tableauDeBordAPI.LignesLoc.CliLigneLoc
          ? [tableauDeBordAPI.LignesLoc.CliLigneLoc]
              .filter((materielAPI) => materielAPI.LignePrixHT === 0)
              .map((materielAPI) => Materiel.factory(materielAPI))
          : undefined,

      tableauDeBordAPI.LignesVte.CliLigneVte instanceof Array
        ? tableauDeBordAPI.LignesVte.CliLigneVte.map((materielAPI) =>
            Materiel.factory(materielAPI),
          )
        : tableauDeBordAPI.LignesVte.CliLigneVte
          ? [tableauDeBordAPI.LignesVte.CliLigneVte]
              .filter((materielAPI) => materielAPI.LignePrixHT === 0)
              .map((materielAPI) => Materiel.factory(materielAPI))
          : undefined,
    );
  }
}

export type TableauDeBordAPI = {
  ChampsLibres: {
    CliChampLibre?: ChampLibreAPI[] | ChampLibreAPI;
  },
  LignesLoc: {
    CliLigneLoc?: MaterielAPI[] | MaterielAPI;
  },
  LignesVte: {
    CliLigneVte?: MaterielAPI[] | MaterielAPI;
  }
};
